export const emptySetterFunction = (_) => {};
export const emptyFunction = () => {};